export default {
    title: 'Chat',
    messages: 'messages',
    leaveReply: 'Leave a reply',
    searchMessages: 'Search messages',
    filter: {
        allMessages: 'All messages',
        unreadMessages: 'Unread messages',
        orders: 'Orders',
        unreadOrders: 'Unread orders'
    },
    sidebar: {
        order: 'Order'
    },
    chatHeader: {
        orderNumber: 'Order number'
    },
    modal: {
        askSellerAQuestion: 'Ask seller a question',
        sendCustomerMessage: 'Send customer a message'
    }
};
